import { CanActivateFn } from '@angular/router';
import { inject, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';
import { Observable, of } from 'rxjs';
import { switchMap, catchError } from 'rxjs/operators';
import { isPlatformBrowser } from '@angular/common';

export const LoginAsUserGuard: CanActivateFn = (route, state) => {
    const platformId = inject(PLATFORM_ID);
    const router = inject(Router);
    const authService = inject(AuthService);

    const guid = route.paramMap.get('guid');

    if (!guid) {
        router.navigate(['/notfound']);
        return of(false);
    }

    return authService.loginasUser(guid).pipe(
        switchMap((res: any) => {
            if (isPlatformBrowser(platformId)) {
            if (res?.jwtToken) {
                localStorage.setItem('AccessToken', res.jwtToken);
                document.cookie = `ihoLoggedIn=1; path=/; max-age=${60 * 60 * 24 * 30}`;
                authService.userProfile();
                //persian/userprofile/#/dashboard
                router.navigate([res?.redirectUrl]);
                return of(true);
            } else {
                router.navigate(['/notfound']);
                return of(false);
            }
            }
            else {
                // اگر SSR هست، هیچ کاری نکن (یا می‌تونی یه مقدار دیفالت برگردونی)
                return of(false);
              }
        }),
        catchError((error) => {
            console.error('Login as user failed', error);
            router.navigate(['/notfound']);
            return of(false);
        })
    );
};
